const packageInfo = { version: '12.4.0' };

export const version = packageInfo.version;
export default packageInfo;
